<template>
  <header class="w-full grid grid-cols-3 md:place-items-center px-10 py-3.5 md:px-10 md:pt-15">
    <div class="logo col-start-2 h-15 grid place-items-cente w-full">
      <a
        :title="urls.logo ?? 'https://www.drhauschka.de/'"
        :href="urls.logo ?? 'https://www.drhauschka.de/'"
        target="_blank"
        class="relative w-full grid place-content-center"
        data-test="logo"
      >
        <logo-full key="logo-full" width="116" />
      </a>
    </div>
    <div
      class="exit col-start-3 justify-self-end grid md:grid-flow-col md:place-items-baseline md:gap-x-13 md:sticky top-4 self-start"
    >
      <module-reset
        v-if="isResultView"
        :text="textSnippets.repeat_skin_advice"
        @restartQuiz="$emit('restartQuiz')"
        class="hidden md:flex"
      />
      <div
        @click.prevent="closeModal"
        data-test="close"
        class="grid grid-flow-col place-content-center md:items-end cursor-pointer"
      >
        <close class="w-4" :class="{ 'opacity-0': store.cartOpen }" />
      </div>
      <feature name="disable-cart">
        <base-cart-icon
          v-if="isResultView"
          :cart-counter="cartCounter"
          @click="store.openCart()"
          data-test="cart-icon"
          class="cursor-pointer mt-4 md:mt-0 md:col-start-1"
        />
      </feature>
    </div>
  </header>
</template>

<script lang="ts" setup>
import { FeatureToggleComponent as feature } from 'vue-feature-toggle'
import { toRefs } from 'vue'
import logoFull from '@/assets/logo-full.svg'
import close from '@/assets/icons/close.svg'
import BaseCartIcon from '@/components/base/BaseCartIcon.vue'

import { inject, computed } from 'vue'
import { useMainStore } from '@/store/main'
import ModuleReset from '@/components/module/ModuleReset.vue'

const props = defineProps({
  isResultView: Boolean,
  showProgress: Boolean,
  scrollContainer: HTMLElement,
})

const { isResultView } = toRefs(props)

/**
 * register Store
 */
const store = useMainStore()

const cartCounter = computed(() => store.cartCounter)

/**
 * @description inject the global toggleModal function
 */
const toggleModal = inject('toggleModal') as Function

/**
 * @description exported function to close modal in template
 */
const closeModal = () => {
  if (!store.cartOpen) toggleModal()
}

/**
 * @return {Language} textSnippets
 */
const textSnippets = computed(() => store.snippets)

/**
 * @return {Urls} urls
 */
const urls = computed(() => store.urls)
</script>
